import apiClient from './client';

export interface PublicConfig {
  // REMOTE_HANDOVER_SIGNING flag — the single predicate for the remote
  // warranty-signing flow. Public, no auth.
  remoteHandoverSigning: boolean;
  // Effective portal magic-link flag (backend ANDs PORTAL_MAGIC_LINK with the
  // PORTAL_LINK_SECRET being configured). Public, no auth.
  portalMagicLink: boolean;
}

export const configApi = {
  getPublicConfig: () => apiClient.get<PublicConfig>('/config'),
};
